import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { errorMessage: String, failedAttemptsUrl: String }

  connect() {
    this.element.dataset.remoteFormReady = "true"
  }

  disconnect() {
    this.request?.abort()
    delete this.element.dataset.remoteFormReady
  }

  async submit(event) {
    event.preventDefault()
    this.clearErrors()
    this.setSubmitting(true)
    this.request?.abort()
    this.request = new AbortController()

    try {
      const response = await fetch(this.element.action, {
        method: this.element.method,
        body: new FormData(this.element),
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        signal: this.request.signal
      })

      const data = await response.json()
      if (data.failed_attempts > 2 && this.hasFailedAttemptsUrlValue) {
        window.location.assign(this.failedAttemptsUrlValue)
        return
      }

      if (response.ok) {
        Turbo.visit(window.location.href, { action: "replace" })
        return
      }

      this.showErrors(data.errors || data)
    } catch (error) {
      if (error.name !== "AbortError") this.showErrors({ base: [this.errorMessageValue] })
    } finally {
      this.request = null
      this.setSubmitting(false)
    }
  }

  clearFieldError(event) {
    event.target.closest(".form-group")?.classList.remove("error")
  }

  clearErrors() {
    this.element.querySelectorAll(".form-group.error").forEach(group => group.classList.remove("error"))
    this.element.closest(".modal-body")?.querySelector("[data-remote-form-alert]")?.remove()
  }

  showErrors(errors) {
    Object.entries(errors).forEach(([field, messages]) => {
      const input = Array.from(this.element.elements).find(element => element.id.endsWith(`_${field}`))
      input?.closest(".form-group")?.classList.add("error")
      this.addMessages(Array(messages))
    })
  }

  addMessages(messages) {
    const modalBody = this.element.closest(".modal-body")
    if (!modalBody || messages.length === 0) return

    let alert = modalBody.querySelector("[data-remote-form-alert]")
    if (!alert) {
      alert = document.createElement("div")
      alert.className = "alert alert-danger"
      alert.role = "alert"
      alert.dataset.remoteFormAlert = "true"
      modalBody.prepend(alert)
    }

    messages.forEach(message => {
      const paragraph = document.createElement("p")
      paragraph.textContent = message
      alert.append(paragraph)
    })
  }

  setSubmitting(submitting) {
    this.element.querySelectorAll("input[type='submit'], button[type='submit']").forEach(button => {
      button.disabled = submitting
    })
  }
}
